// Declared twice so that docs appear when selecting colors
export interface PrimaryPalette extends Record<string, string> {
  /** **#36BCA2** Green */
  readonly successPrimary: string;
  /** **#39ABD1** Blue (Brand Color) */
  readonly tempusPrimary: string;
  /** **#D7303B** Red */
  readonly errorPrimary: string;
  /** **#FB7E34** Orange */
  readonly warningPrimary: string;
  /** **#FFC651** Yellow */
  readonly lemonPrimary: string;
}

export const primaryPalette: PrimaryPalette = {
  successPrimary: '#36BCA2',
  tempusPrimary: '#39ABD1',
  errorPrimary: '#D7303B',
  warningPrimary: '#FB7E34',
  lemonPrimary: '#FFC651',
};
